import React from 'react';
import { useSelector, useDispatch } from 'react-redux'

/* Snackbar
 * https://notistack.com/api-reference
 */
import { useSnackbar } from 'notistack';

// Components
import AjaxController from './ajaxController';

// Redux slices
import { closeModal } from '../../appSlice'
import { setActivePage, setUser, setToken } from '../../appSlice'
import { setWatchlist } from '../dashboard/dashboardSlice';

// SemanticUI components
import { Modal, Form, FormField, FormTextArea, Button } from 'semantic-ui-react';



/**
 * 
 * @returns 
 */
const Max2ModalWatchlist = () => {
    // local State
    const [note, setNote] = React.useState('');

    // global State
    const dispatch = useDispatch();
    const open          = useSelector((state) => state.app.modal.watchlist.open);
    const itemDetails   = useSelector((state) => state.app.modal.watchlist.data); // { type: [OBJECT|CONTRACT], id: [Item-Id], name: [Item-Name] }
    const userId        = useSelector((state) => state.app.user?.uid);
    const backendUrl    = useSelector((state) => state.app.backend.baseProtocol) + '://' + useSelector((state) => state.app.backend.url);

    // Snackbar
    const { enqueueSnackbar } = useSnackbar();

    // check if modal is active
    if (!open) {
        return <></>
    };



    /**
     * 
     */
    const handleAddToWatchlist = async () => {
        // 
        try {
            // Controller for AJAX requests
            const api = new AjaxController(backendUrl, () => {
                dispatch(setActivePage('START'));
                dispatch(setUser(null));
                dispatch(setToken(null));
            });
      
            // send search request
            const data  = { 
                type:       itemDetails.type,
                id:         itemDetails.id,
                name:       itemDetails.name,
                user_id:    userId,
                note
            }
            const response = await api.post('/watchlist', data);
            
            // display details
            if (response.status === 'success') {
                enqueueSnackbar('Erfolgreich zur Merkliste hinzugefügt', { variant: 'success' });
                dispatch(setWatchlist(response.records));        
                dispatch(closeModal('watchlist'));
            }
        } catch (err) {
            console.error(err.message);
            enqueueSnackbar('Fehler beim Hinzufügen zur Merkliste', { variant: 'error' });
        }

        dispatch(closeModal('watchlist'));
    }

  
    return (
        <Modal dimmer="blurring" open={open} size="small" onClose={() => dispatch(closeModal('watchlist'))}>
            <Modal.Header>{itemDetails.type === 'OBJECT' ? 'Hotel' : 'Vertrag'} &laquo;{itemDetails.name}&raquo; zur Merkliste hinzufügen</Modal.Header>
            <Modal.Content scrolling>
                <Form>
                    <FormField>
                        <FormTextArea label='Anmerkung' placeholder='Anmerkung hinzufügen' value={note} onChange={(e, data)=>setNote(data.value)}></FormTextArea>
                    </FormField>
                    <FormField>
                        <br />
                    </FormField>
                    <FormField>
                        <Button 
                            circular
                            positive
                            floated         = "right" 
                            content         = "Hinzufügen"
                            labelPosition   = 'left'
                            icon            = 'add'
                            onClick         = {() => handleAddToWatchlist()}
                        />
                        <Button circular floated="right" onClick={() => dispatch(closeModal('watchlist'))}>Abbrechen</Button>
                    </FormField>
                </Form>
            </Modal.Content>
        </Modal>
    )
}

export default Max2ModalWatchlist;